module.exports = __webpack_public_path__ + "img/ico_btn_cart.9a2eb00.svg";